import React, { Component } from 'react';
//Styles
import '../../styles/LoginPage.scss';
// Images
import lh_logo from '../../assets/lh_logo_hq_sm.png';
import aw_logo from '../../assets/logo.png';
// Material UI
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import { AccountCircle, VpnKey } from '@material-ui/icons';
import FormControl from '@material-ui/core/FormControl';

// LOCAL
import ResetPassword from './ResetPassword';
import ResetTempPassword from './ResetTempPassword';
import MFABox from './MFABox';
import { GENERAL, MFA } from '../../constants/errorMessage';
import regex from '../../constants/regex';
import { oktaErrorService } from '../../services/oktaError.service';
import { setLocalStorageByKey } from '../../util/storage';
import axios from 'axios';

type MyProps = {
  errorMessage: string,
  app: string,
  redirectUrl: string
};

type MyState = {
  formControls: {
    username: string, password: string,
  },
  errors: {
    username: string, password: string, login: string,
  },
  message: string,
  tempPassword: string,
  resetPasswordWithEmailLink: boolean,
  resetTempPassword: boolean,
  showMFAPopup: boolean,
  emailFactorId: string,
  stateToken: string,
  userId: string
};

class LoginBox extends Component<MyProps, MyState> {

  constructor(props: any) {
    super(props);
    this.state = {
      formControls: {
        username: '', password: '',
      },
      errors: {
        username: '', password: '', login: '',
      },
      message: '',
      tempPassword: '',
      resetPasswordWithEmailLink: false,
      resetTempPassword: false,
      showMFAPopup: false,
      emailFactorId: '',
      stateToken: '',
      userId: ''
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleForgetPasswordStep = this.handleForgetPasswordStep.bind(this);
    this.login = this.login.bind(this);
    this.goBack = this.goBack.bind(this);
    this.handleVerifyFactor = this.handleVerifyFactor.bind(this);
  }

  submitForm = () => {
    this.login(this.state.formControls.username, this.state.formControls.password);
  }

  goBack = () => {
    this.setState({
      ...this.state,
      resetPasswordWithEmailLink: false,
      resetTempPassword: false,
      showMFAPopup: false,
      errors: {
        username: '', password: '', login: '',
      }
    });
  }

  handleChange(event: any) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      ...this.state,
      errors: {
        username: '', password: '', login: '',
      },
      formControls: {
        ...this.state.formControls,
        [name]: value
      },
    });
  }

  async login(username: string, password: string) {
    this.setState({
      ...this.state,
      errors: {
        ...this.state.errors,
        login: '',
      }
    })
    const baseUrl = process.env['REACT_APP_API_URL'];
    let redirectUrl = this.props.redirectUrl;
    let app = this.props.app;

    return axios.post(`${baseUrl}/auth/login`, {
      username,
      password,
      app,
      redirectUrl
    }).then((res: any) => {
      if (res.data.resetPassword) {
        this.setState({
          ...this.state,
          tempPassword: password,
          resetTempPassword: true,
          resetPasswordWithEmailLink: false,
          stateToken: res.data.stateToken
        });
      } else if (res.data.errorSummary) {
        const error = oktaErrorService(res.data);
        this.setState({
          ...this.state,
          errors: {
            ...this.state.errors,
            login: error as string
          }
        });
      } else if (res.data.mfaRequired) {
        if (res.data.status === 'MFA_REQUIRED') {
          this.setState({
            ...this.state,
            showMFAPopup: true,
            emailFactorId: res.data.factorId,
            stateToken: res.data.stateToken,
            userId: res.data.userId,
            tempPassword: password,
          });
        }
      } else if (res.data.url != null && res.data.sessionToken != null) {
        setLocalStorageByKey('sessionToken', res.data.sessionToken).then(() => {
          this.setState({ message: res['message'] });
          window.location.href = res.data.url;
        });
      } else {
        // unknown error has occurred.
        this.setState({
          ...this.state,
          errors: {
            ...this.state.errors,
            login: GENERAL.UNKNOWN_ERROR
          }
        });
      }
    }).catch((err: any) => {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          login: GENERAL.UNKNOWN_ERROR
        }
      })
    })
  }

  handleVerifyFactor = async (passCode: string) => {
    const baseUrl = process.env['REACT_APP_API_URL'];
    let redirectUrl = this.props.redirectUrl;
    try {
      const response = await axios.post(`${baseUrl}/auth/verify-mfa`, {
        factorId: this.state.emailFactorId,
        passCode,
        stateToken: this.state.stateToken,
        redirectUrl,
        app: this.props.app
      }).then((res: any) => res);
      const { sessionToken, url, status } = response.data;
      if (sessionToken && url) {
        await setLocalStorageByKey('sessionToken', sessionToken);
        this.setState({ message: response['message'] as string });
        window.location.href = url;
      } else if (status === 'PASSWORD_EXPIRED') {
        this.setState({
          ...this.state,
          resetTempPassword: true,
          resetPasswordWithEmailLink: false,
          showMFAPopup: false
        });
      } else {
        if (response.data.errorSummary || response.data.error) {
          this.setState({
            ...this.state,
            errors: {
              ...this.state.errors,
              login: MFA.INCORRECT_CODE
            }
          });
        }
      }
    } catch (error) {
      this.setState({
        ...this.state,
        errors: {
          ...this.state.errors,
          login: MFA.VERIFY_ERROR
        }
      });
    }
  }

  handleSubmit(event: any) {
    this.validateFields();
    event.preventDefault();
  }

  handleForgetPasswordStep(event: any) {
    this.setState({
      ...this.state,
      resetPasswordWithEmailLink: true,
      resetTempPassword: false,
    });
    event.preventDefault();
  }

  validateFields() {
    let isValid = true;
    this.setState({
      ...this.state,
      errors: {
        username: '', password: '', login: '',
      }
    })
    let usernameError = '';
    let passwordError = '';
    if (this.state.formControls.password === '' || !this.state.formControls.password) {
      passwordError = 'Please enter a password';
      isValid = false;
    }
    if (this.state.formControls.username === '' || !this.state.formControls.username || !(regex.USERNAME.test(this.state.formControls.username))) {
      usernameError = 'Please enter a valid email';
      isValid = false;
    }
    this.setState({
      ...this.state,
      errors: {
        ...this.state.errors,
        username: usernameError,
        password: passwordError
      }
    })
    if (isValid) {
      this.submitForm();
    }
  }

  render() {
    return (
      <div>
        <Box >
          <Grid
            container
            className="login-box"
            direction="column"
            alignItems="center"
            justifyContent="space-evenly"
          >
            <Grid className="header-container"
              container
              direction="column"
              justifyContent="center"
              alignItems="center">
              <div className="lighthouse-logo">
                <img
                  alt='LightHouse'
                  src={lh_logo} />
              </div>
            </Grid>
            <Grid
              className="login-body"
              container
              direction="column"
              justifyContent="space-evenly"
              alignItems="center">
              {this.state.resetPasswordWithEmailLink ? <ResetPassword
                username={this.state.formControls.username}
                goBack={this.goBack}
                app={this.props.app}
                redirectUrl={this.props.redirectUrl}
                login={this.login} /> : null}
              {this.state.showMFAPopup && (
                <MFABox
                  onClose={this.goBack}
                  handleVerifyFactor={this.handleVerifyFactor}
                />
              )}
              {this.state.resetTempPassword ? <ResetTempPassword
                goBack={this.goBack}
                tempPassword={this.state.tempPassword}
                stateToken={this.state.stateToken}
                app={this.props.app}
                redirectUrl={this.props.redirectUrl}
                login={this.login}
                username={this.state.formControls.username}
              /> : null}
              <form onSubmit={this.handleSubmit}
                className="login-input"
              >
                <Grid
                  container
                  direction="column"
                  justifyContent="space-evenly"
                  alignItems="center">
                  <FormControl className="form-box" >
                    {!this.state.resetTempPassword && !this.state.resetPasswordWithEmailLink && !this.state.showMFAPopup &&
                      (<TextField
                        id="username"
                        name="username"
                        required
                        value={this.state.formControls.username}
                        onChange={this.handleChange}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountCircle />
                            </InputAdornment>
                          ),
                        }}
                        error={this.state.errors.username !== ''}
                        className="input-color"
                        label="User Name"
                        margin="normal"
                        variant="outlined" />)}
                    {!this.state.resetPasswordWithEmailLink && !this.state.resetTempPassword && !this.state.showMFAPopup &&
                      (<TextField
                        id="password"
                        label="Password"
                        required
                        name="password"
                        value={this.state.formControls.password}
                        onChange={this.handleChange}
                        margin="normal"
                        variant="outlined"
                        type="password"
                        error={this.state.errors.password !== ''}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <VpnKey />
                            </InputAdornment>
                          ),
                        }}
                      />)
                    }
                    <div className="button-container">
                      {!this.state.resetPasswordWithEmailLink && !this.state.resetTempPassword && !this.state.showMFAPopup ?
                        < Button
                          type="submit"
                          name="continue"
                          variant="contained"
                          size="large"
                          classes={{ label: 'button-label' }}
                          className="button">Sign In
                        </Button>
                        : null}
                    </div>
                  </FormControl>
                </Grid>
              </form>
            </Grid>
            {!this.state.resetPasswordWithEmailLink ?
              <div className="error-messages">
                {this.state.errors.username}
                {this.state.errors.password}
                {this.state.errors.login}
                {this.props.errorMessage}
              </div> : null}
            {!this.state.resetPasswordWithEmailLink && !this.state.resetTempPassword && !this.state.showMFAPopup &&
              (<Grid className="password-reset-box"
                container
                direction="column"
                justifyContent="center"
                alignItems="center">
                <Grid className="password-reset-box"
                  container
                  direction="column"
                  justifyContent="center"
                  alignItems="center">
                  <div className="password-reset-text">If you have received a temporary password from AnalysisWorks,
                    enter your username and temporary password above.</div>
                  <button className="back-button" onClick={this.handleForgetPasswordStep}>Forgot Password?</button>
                  <div className="password-reset-text">Click the above link to reset your LightHouse password.</div>
                </Grid>
              </Grid>)
            }
            <Grid className="footer-box"
              container
              direction="column"
              justifyContent="center"
              alignItems="center">
              <div className="powered-by">
                <Typography variant="caption">  Powered By </Typography>
              </div>
              <div className="aw-logo">
                <img
                  alt='AW Logo'
                  src={aw_logo} />
              </div>
            </Grid>
          </Grid>
        </Box>
      </div >
    )
  }
}

export default LoginBox;
